import styled from '@emotion/styled';
import { Fonts, Spacings, mediaQuery } from '@styles/index';
import Image from '@base/Image';
import P1 from '@base/P1/P1';

const Wrapper = styled.div`
  width: 100%;
  margin-top: ${Spacings.SPACING_94};
  margin-bottom: ${Spacings.SPACING_94};
  ${mediaQuery.uptoTablet} {
    margin-bottom: ${Spacings.SPACING_10B};
    max-width: 100%;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 170px;
  height: ${Spacings.SPACING_30B};
  margin-left: -${Spacings.SPACING_18};
  img {
    border-radius: ${Spacings.SPACING_2B};
  }
  ${mediaQuery.uptoMobile} {
    width: 100%;
    height: 0 auto;
  }
`;

const HeadingWrapper = styled.div`
  color: var(--color-i-black);
  font-size: ${Fonts.H2};
  font-weight: ${Fonts.HEAVY};
  line-height: ${Spacings.SPACING_10B};
  margin-top: ${Spacings.SPACING_6B};
`;

const HR = styled.hr`
  background-color: var(--color-i-green-99);
  height: ${Spacings.SPACING_1};
  border: none;
  margin-top: ${Spacings.SPACING_6B};
  max-width: 85%;
`;

const OfferingWrapper = styled.div`
  display: flex;
  align-items: start;
  margin-top: ${Spacings.SPACING_6B};
  img {
    padding-top: ${Spacings.SPACING_2} !important;
  }
`;

const OfferingText = styled(P1)`
  color: var(--color-i-black);
  font-size: ${Fonts.P1};
  font-weight: ${Fonts.SEMIBOLD};
  padding-left: ${Spacings.SPACING_2B};
  line-height: ${Spacings.SPACING_18};
  max-width: 50%;
`;

const EnquiryStaticInfo = () => {
  const offerings = [
    'Learn face-to-face from the best educators in your city',
    'Access high-tech library, spacious classrooms, cafe and more',
    'Regular educator-parent connect'
  ];
  return (
    <Wrapper>
      <ImageWrapper>
        <Image
          src="allCentre/EnquiryFormImage.svg"
          alt="all-centre-enquiry-form"
          layout="fill"
        />
      </ImageWrapper>
      <HeadingWrapper>
        Book a call with us for any query regarding centres
      </HeadingWrapper>
      <HR />
      {offerings?.map((offering, index) => (
        <OfferingWrapper key={String(index)}>
          <Image
            src="allCentre/AllCentreOffering.svg"
            width={18}
            height={18}
            alt="all-centre-offering"
          />
          <OfferingText>{offering}</OfferingText>
        </OfferingWrapper>
      ))}
    </Wrapper>
  );
};

export default EnquiryStaticInfo;
